import { Sparkles } from 'lucide-react'

import { cn } from '@modules/lib/lib'
import { Button } from '@modules/shadcn/ui/Button/Button'

interface ExecutionPanelProps {
  disabled: boolean
  label: string
  message?: string
  onClick: () => void
}

/**
 * 実行コンポーネント
 */
export const ExecutionPanel: React.FC<ExecutionPanelProps> = ({
  disabled,
  label,
  message,
  onClick,
}) => {
  return (
    <div className="w-full space-y-2">
      {disabled && message ? <p className="text-xs text-slate-700">{message}</p> : null}
      <Button
        className={cn('w-full gap-2', disabled && 'opacity-50')}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        <Sparkles aria-hidden className="h-4 w-4" />
        {label}
      </Button>
    </div>
  )
}
